import { createBrowserRouter, Outlet, type RouteObject } from 'react-router-dom';
import { ScrollToTop } from './ScrollToTop';
import { NotFoundPage } from './placeholders/NotFoundPage';
import { UnderConstruction } from './placeholders/UnderConstruction';
import { EVENTS } from '@/features/events';
import { ConsentBanner, RouteTracking } from '@/features/tracking';
import { TourHubPage } from '@/pages/TourHubPage';
import { BuenosAiresPage } from '@/pages/BuenosAiresPage';
import { FunesPage } from '@/pages/FunesPage';
import { BogotaPage } from '@/pages/BogotaPage';
import { MexicoCityPage } from '@/pages/MexicoCityPage';
import { CancunVipPage } from '@/pages/CancunVipPage';

/* =============================================================================
 * RUTAS DE LA SPA · 6 paginas + 404 propia.
 * -----------------------------------------------------------------------------
 * Las 5 rutas de destino NO estan escritas a mano: salen de `EVENTS`. Si manana
 * cambia un slug en la config tipada, cambia la ruta, el menu y el enlace del
 * hub a la vez. Es imposible que se descuadren.
 *
 * FASE 1 — COMO SUSTITUIR UN PLACEHOLDER POR LA PAGINA REAL:
 * `router.tsx` esta bajo el lock `router` de FORGE-ALPHA, PERO se autoriza
 * expresamente a cada FORGE de paginas a cambiar SOLO su linea del mapa
 * `PAGES` de aqui abajo (y anadir su `import`). Cualquier otro cambio en este
 * fichero se pide a FORGE-ALPHA. Ver docs/PAGE_CONTRACT.md §Sustitucion.
 * ========================================================================== */

/** slug -> componente de pagina. Hoy, placeholders honestos. */
const PAGES: Record<string, () => React.ReactElement> = {
  // '/' lo cubre `hubElement`; aqui van los 5 destinos.
  funes: () => <FunesPage />,
  'buenos-aires': () => <BuenosAiresPage />,
  bogota: () => <BogotaPage />,
  mexico: () => <MexicoCityPage />,
  cancun: () => <CancunVipPage />,
};

const hubElement = () => <TourHubPage />;

function RootLayout() {
  return (
    <>
      <ScrollToTop />
      {/* Mide los cambios de ruta. No pinta nada y no hace NADA mientras no haya
       * consentimiento; ver `features/tracking`. */}
      <RouteTracking />
      <Outlet />
      {/* El banner va al final del arbol para que sea lo ultimo del orden de
       * tabulacion: quien navega con teclado llega primero al contenido de la
       * pagina, no a una pregunta sobre cookies. */}
      <ConsentBanner />
    </>
  );
}

const destinationRoutes: RouteObject[] = EVENTS.map((event) => {
  const Page = PAGES[event.slug];
  return {
    path: event.path,
    element: Page ? <Page /> : <UnderConstruction event={event} />,
  };
});

export const routes: RouteObject[] = [
  {
    element: <RootLayout />,
    children: [
      { path: '/', element: hubElement() },
      ...destinationRoutes,
      // Comodin: cualquier otra direccion cae en la 404 propia del sitio.
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
